@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="tbsOpbrengsten">
      @for (item of tbsOpbrengsten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving opbrengsten' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [required]=true
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedragRow"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijOpbrengsten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>

    <snelstart-ui-button (click)="addRijOpbrengsten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Opbrengsten toevoegen
    </snelstart-ui-button>

    <div formArrayName="tbsKosten">
      @for (item of tbsKosten.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijKosten(i)"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 class="col-auto"
                                 icon="trash"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
    <snelstart-ui-button (click)="addRijKosten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Kosten toevoegen
    </snelstart-ui-button>

    @if(isDefAangifte) {
      <div formArrayName="tbsBezittingen">
        @for (item of tbsBezittingen.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Bezittingen TBS' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Waarde opening' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="waardeOpening"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Waarde slot' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="waardeSlot"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRijTbsBezittingen(i)"
                                   [class]="i === 0 ? 'firstrowbutton' : ''"
                                   class="col-auto"
                                   icon="trash"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
      <snelstart-ui-button (click)="addRijTbsBezittingen()" class="snelstart-ui-button pb-3" icon="plus"
                           type="link">Bezitting toevoegen
      </snelstart-ui-button>

      <div formArrayName="tbsOnroerendeZaken">
        @for (item of tbsOnroerendeZaken.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Onroerende zaak TBS' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Waarde opening' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="waardeOpening"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Waarde slot' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="waardeSlot"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRijTbsOnrZaken(i)"
                                   [class]="i === 0 ? 'firstrowbutton' : ''"
                                   class="col-auto"
                                   icon="trash"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
      <snelstart-ui-button (click)="addRijTbsOnrZaken()" class="snelstart-ui-button pb-3" icon="plus"
                           type="link">Onroerende zaak toevoegen
      </snelstart-ui-button>

      <div formArrayName="tbsSchulden">
        @for (item of tbsSchulden.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <div class="col-auto row" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Schuld TBS' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Waarde opening' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="waardeOpening"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Waarde slot' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="waardeSlot"
                                                prefix="€"

              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRijTbsSchulden(i)"
                                   [class]="i === 0 ? 'firstrowbutton' : ''"
                                   class="col-auto"
                                   icon="trash"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
      <snelstart-ui-button (click)="addRijTbsSchulden()" class="snelstart-ui-button" icon="plus"
                           type="link">Schuld toevoegen
      </snelstart-ui-button>
    }
  </form>
}
